import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import BriaSlider from "../../../../../../components/common/BriaSlider/BriaSlider";
import { DEFAULT_TAILORED_MODEL_INFLUENCE } from "../../../../../../constants/TextToImageConstants";
import { useAppStore } from "../../../../../../hooks/useStores";
import InputLayout from "../../../../../../layout/InputLayout/InputLayout";

const TgInfluenceSlider = () => {
	const { t } = useTranslation("tg", { keyPrefix: "app.image.config.influence" });
	const { textToImageStore } = useAppStore();
	const { handleConfigChange } = textToImageStore;

	useEffect(() => {
		handleConfigChange("tailored_model_influence", DEFAULT_TAILORED_MODEL_INFLUENCE);

		return () => {
			if (!textToImageStore.config.tailored_model_id) {
				delete textToImageStore.config.tailored_model_influence;
			}
		};
	}, []);

	return (
		<InputLayout label={t("label")} info={t("info")}>
			<BriaSlider
				value={textToImageStore.config.tailored_model_influence ?? DEFAULT_TAILORED_MODEL_INFLUENCE}
				onChange={(_, value) => handleConfigChange("tailored_model_influence", value as number)}
				step={0.05}
				min={0}
				max={1}
				marks={[
					{ value: 0, label: t("low") },
					{ value: 1, label: t("high") },
				]}
				valueLabelDisplay="auto"
				labelsAlwaysGray
			/>
		</InputLayout>
	);
};

export default observer(TgInfluenceSlider);
